
import type { RouteObject } from "react-router-dom";
import { createElement } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Sluzby from "../pages/sluzby/page";
import SluzbyDetailne from "../pages/sluzby-detailne/page";
import ONas from "../pages/o-nas/page";
import Kontakt from "../pages/kontakt/page";

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/sluzby',
    element: <Sluzby />
  },
  {
    path: '/sluzby-detailne',
    element: <SluzbyDetailne />
  },
  {
    path: '/o-nas',
    element: <ONas />
  },
  {
    path: '/kontakt',
    element: <Kontakt />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
